'use client';

import { Dispatch, SetStateAction, useEffect, useState } from 'react';

import breakpoints from '@/lib/breakpoints';
import { cn } from '@/lib/utils';
import { useMediaQuery } from '@/hooks/useMediaQuery';
import useScrollSpy from '@/hooks/useScrollSpy';

import UnstyledLink from '../links/UnstyledLink';
import ProgressBarHomepage from '../ProgressBarHomepage';

type NavigationItem = {
  sectiontitle: string;
  sectionid: string;
};

type NavigationHomePageProps = {
  navigationlist: NavigationItem[];
};

export default function NavigationHomePage(props: NavigationHomePageProps) {
  const { navigationlist } = props;
  const isDesktop = useMediaQuery(`(min-width: ${breakpoints.lg})`);
  const [showNav, setShowNav] = useState(false);
  const [desktop, setDesktop]: [
    boolean | undefined,
    Dispatch<SetStateAction<boolean | undefined>>,
  ] = useState();
  const activeId = useScrollSpy(
    navigationlist.map((item) => item.sectionid),
    desktop ? 150 : 80,
    'key-visual',
  );

  useEffect(() => {
    setDesktop(isDesktop);

    setTimeout(() => setShowNav(true), 100);
  }, [isDesktop]);

  return (
    <>
      {desktop && navigationlist?.length > 0 && (
        <div className='absolute -mt-px w-full xl:mt-0 2xl:-bottom-[45px]'>
          <nav
            className={cn(
              'z-10 block h-auto w-full bg-primary-900',
              'transition-opacity duration-500 ease-linear',
              showNav ? 'opacity-100' : 'opacity-0',
            )}
          >
            <ul
              className={cn(
                'main-nav',
                'flex flex-row items-stretch justify-between p-0 text-sm',
                showNav && 'active',
              )}
            >
              {navigationlist.map((item, index) => (
                <li
                  key={item.sectionid}
                  className='block w-full opacity-0 transition-opacity duration-500 ease-linear'
                  style={{
                    transitionDelay: `${50 + 75 * index}ms`,
                  }}
                >
                  <UnstyledLink
                    href={`#${item.sectionid}`}
                    className={cn(
                      'flex h-full w-full items-center justify-center px-1 py-2 text-center leading-tight transition-all duration-300 ease-in-out xl:px-2 xl:py-3',
                      item.sectionid === activeId
                        ? 'bg-blue-500/80 hover:bg-blue-500'
                        : 'bg-transparent hover:bg-white hover:bg-opacity-5',
                    )}
                    scrollToAnchor
                  >
                    {item.sectiontitle}
                  </UnstyledLink>
                </li>
              ))}
            </ul>
          </nav>
          <ProgressBarHomepage color='white' />
        </div>
      )}
    </>
  );
}
